import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth as authApi } from '../api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('c3_token');
    const email = localStorage.getItem('c3_email');
    if (token && email) setUser({ email });
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const data = await authApi.login(email, password);
    localStorage.setItem('c3_token', data.idToken);
    localStorage.setItem('c3_refresh', data.refreshToken);
    localStorage.setItem('c3_email', email);
    setUser({ email });
  };

  const register = async (email, password) => {
    const data = await authApi.register(email, password);
    localStorage.setItem('c3_token', data.idToken);
    localStorage.setItem('c3_refresh', data.refreshToken);
    localStorage.setItem('c3_email', email);
    setUser({ email });
  };

  const logout = () => {
    localStorage.removeItem('c3_token');
    localStorage.removeItem('c3_refresh');
    localStorage.removeItem('c3_email');
    setUser(null);
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
